export const image_size_thai = [
    {
        image_name: 'low_r',
        width_image: 100,
        height_image: 140
    },
    {
        image_name: 'moderate_r',
        width_image: 240,
        height_image: 140
    },
    {
        image_name: 'high_r',
        width_image: 365,
        height_image: 140
    }
]

export const text_config_thai = [
    {
        // Allergy & Eczema
        page: 15,
        value_comparing: [
            'Asthma',
            'Food allergy',
            'Eczema',
            'Allergic rhinitis'
        ],
        mapping_text: [
            {
                min: 0, 
                max: 3, 
                color_dot: '#8bcc2c', 
                label: ['จากข้อมูลไมโครไบโอมในลำใส้ของคุณ คุณมีความเสี่ยงใน ระดับต่ำ ','ต่อการเกิดอาการแพ้ ภาวะผิวหนังอักเสบ และความไวต่อระบบทางเดินหายใจ'], 
                img: 'low_r',
                posX_image: 130,
                posY_image: 310,
                posX_text: 248,
                posY_text: 350,
                fontFamily: '"Noto Sans Thai", sans-serif',

                label_2: ['โปรไฟล์ไมโครไบโอมในลำไส้ของคุณในปัจจุบันแสดงความเสี่ยง ระดับต่ำ ต่อการ','เกิดภาวะที่เกี่ยวข้องกับภูมิคุ้นกัน เช่น ภูมิแพ้ ผื่นภูมิแพ้ และความไวต่อสารก่อภูมิแพ้ทางเดินหายใจ'],
                Xlabel_2: 50,
                Ylabel_2: 240,
                fontFamily_label_2: '"Noto Sans Thai", sans-serif'
            },
            {
                min: 4, 
                max: 6, 
                color_dot: '#fa891f',
                label: ['จากข้อมูลไมโครไบโอมในลำใส้ของคุณ คุณมีความเสี่ยงใน',' ระดับปานกลาง ต่อการเกิดอาการแพ้ ภาวะผิวหนังอักเสบ',' และความไวต่อระบบทางเดินหายใจ'],
                img: 'moderate_r',
                posX_image: 50,
                posY_image: 310,
                posX_text: 300,
                posY_text: 335,
                fontFamily: '"Noto Sans Thai", sans-serif',

                label_2: ['โปรไฟล์ไมโครไบโอมในลำไส้ของคุณในปัจจุบันแสดงความเสี่ยง ระดับปานกลาง ต่อการ','เกิดภาวะที่เกี่ยวข้องกับภูมิคุ้นกัน เช่น ภูมิแพ้ ผื่นภูมิแพ้ และความไวต่อสารก่อภูมิแพ้ทางเดินหายใจ'],
                Xlabel_2: 50,
                Ylabel_2: 240,
                fontFamily_label_2: '"Noto Sans Thai", sans-serif'
            },
            {
                min: 7, 
                max: 100, 
                color_dot: '#fa1f1f', 
                label: ['จากข้อมูลไมโครไบโอมในลำใส้ของคุณ คุณมีความเสี่ยงใน',' ระดับสูง ต่อการเกิดอาการแพ้ ภาวะผิวหนังอักเสบ',' และความไวต่อระบบทางเดินหายใจ'],
                img: 'high_r',
                posX_image: 50,
                posY_image: 310,
                posX_text: 427,
                posY_text: 332,
                fontFamily: '"Noto Sans Thai", sans-serif',

                label_2: ['โปรไฟล์ไมโครไบโอมในลำไส้ของคุณในปัจจุบันแสดงความเสี่ยง ระดับสูง ต่อการ','เกิดภาวะที่เกี่ยวข้องกับภูมิคุ้นกัน เช่น ภูมิแพ้ ผื่นภูมิแพ้ และความไวต่อสารก่อภูมิแพ้ทางเดินหายใจ'],
                Xlabel_2: 50,
                Ylabel_2: 240,
                fontFamily_label_2: '"Noto Sans Thai", sans-serif'
            }
        ]
    },
    {
        // Obesity & Metabolic Syndrome
        page: 20,
        value_comparing: [
            'Overweight',
            'Metabolic syndrome',
            'Type 2 diabetes',
            'Excessive lipopolysaccharide'
        ],
        mapping_text: [
            {
                min: 0, 
                max: 3, 
                color_dot: '#8bcc2c', 
                label: ['จากข้อมูลไมโครไบโอมในลำใส้ของคุณ คุณมีความเสี่ยงใน ระดับต่ำ ','ต่อการเกิดโรคอ้วนและกลุ่มอาการเมตาบอลิก'],
                img: 'low_r',
                posX_image: 130,
                posY_image: 230,
                posX_text: 240,
                posY_text: 270,
                fontFamily: '"Noto Sans Thai", sans-serif',

                label_2: ['ผลการวิเคราะห์ของคุณบ่งชี้ถึงความไม่สมดุล ระดับต่ำ ในประชากรจุลินทรีย์ที่เกี่ยวข้องกับ','การควบคุมน้ำหนักและประสิทธิภาพของระบบเผาผลาญ'],
                Xlabel_2: 50,
                Ylabel_2: 157,
                fontFamily_label_2: '"Noto Sans Thai", sans-serif'
            },
            {
                min: 4, 
                max: 6, 
                color_dot: '#fa891f',
                label: ['จากข้อมูลไมโครไบโอมในลำใส้ของคุณ คุณมีความเสี่ยงใน ระดับปานกลาง ','ต่อการเกิดโรคอ้วนและกลุ่มอาการเมตาบอลิก'],
                img: 'moderate_r',
                posX_image: 50,
                posY_image: 230,
                posX_text: 300,
                posY_text: 275,
                fontFamily: '"Noto Sans Thai", sans-serif',

                label_2: ['ผลการวิเคราะห์ของคุณบ่งชี้ถึงความไม่สมดุล ระดับปานกลาง ในประชากรจุลินทรีย์ที่เกี่ยวข้องกับ','การควบคุมน้ำหนักและประสิทธิภาพของระบบเผาผลาญ'],
                Xlabel_2: 50,
                Ylabel_2: 157,
                fontFamily_label_2: '"Noto Sans Thai", sans-serif'
            },
            {
                min: 7, 
                max: 100, 
                color_dot: '#fa1f1f',
                label: ['จากข้อมูลไมโครไบโอมในลำใส้ของคุณ คุณมีความเสี่ยงใน',' ระดับสูง ต่อการเกิดโรคอ้วนและกลุ่มอาการเมตาบอลิก'],
                img: 'high_r',
                posX_image: 50,
                posY_image: 230,
                posX_text: 427,
                posY_text: 275,
                fontFamily: '"Noto Sans Thai", sans-serif',

                label_2: ['ผลการวิเคราะห์ของคุณบ่งชี้ถึงความไม่สมดุล ระดับสูง ในประชากรจุลินทรีย์ที่เกี่ยวข้องกับ','การควบคุมน้ำหนักและประสิทธิภาพของระบบเผาผลาญ'],
                Xlabel_2: 50,
                Ylabel_2: 157,
                fontFamily_label_2: '"Noto Sans Thai", sans-serif'
            }
        ]
    },
    {
        // Intestinal Disease
        page: 28,
        value_comparing: [
            'Constipation',
            'Diarrhea',
            'Immune disorder'
        ],
        mapping_text: [
            {
                min: 0, 
                max: 3, 
                color_dot: '#8bcc2c', 
                label: ['จากข้อมูลไมโครไบโอมในลำใส้ของคุณ คุณมีความเสี่ยงใน ระดับต่ำ ','ต่อความไม่สบายในระบบทางเดินอาหาร โดยเฉพาะอาการท้องผูก',' ท้องเสีย และ ความผิดปกติของระบบภูมิคุ้มกัน'],
                img: 'low_r',
                posX_image: 130,
                posY_image: 230,
                posX_text: 240,
                posY_text: 255,
                fontFamily: '"Noto Sans Thai", sans-serif',

                label_2: ['ภูมิทัศน์ของไมโครไบโอมในลำไส้ของคุณแสดงความเสี่ยง ระดับต่ำ ต่อภาวะไม่สบายใน','ระบบทางเดินอาหาร โดยเฉพาะอาการท้องผูก ท้องเสีย และความผิดปกติของภูมิคุ้มกันในลำใส้'],
                Xlabel_2: 50,
                Ylabel_2: 157,
                fontFamily_label_2: '"Noto Sans Thai", sans-serif'
            },
            {
                min: 4, 
                max: 6, 
                color_dot: '#fa891f',
                label: ['จากข้อมูลไมโครไบโอมในลำใส้ของคุณ คุณมีความเสี่ยงใน ระดับปานกลาง ','ต่อความไม่สบายในระบบทางเดินอาหาร โดยเฉพาะอาการท้องผูก ท้องเสีย ','และ ความผิดปกติของระบบภูมิคุ้มกัน'],
                img: 'moderate_r',
                posX_image: 50,
                posY_image: 230,
                posX_text: 300,
                posY_text: 252,
                fontFamily: '"Noto Sans Thai", sans-serif',

                label_2: ['ภูมิทัศน์ของไมโครไบโอมในลำไส้ของคุณแสดงความเสี่ยง ระดับปานกลาง ต่อภาวะไม่สบายใน','ระบบทางเดินอาหาร โดยเฉพาะอาการท้องผูก ท้องเสีย และความผิดปกติของภูมิคุ้มกันในลำใส้'],
                Xlabel_2: 50,
                Ylabel_2: 157,
                fontFamily_label_2: '"Noto Sans Thai", sans-serif'
            },
            {
                min: 7, 
                max: 100, 
                color_dot: '#fa1f1f',
                label: ['จากข้อมูลไมโครไบโอมในลำใส้ของคุณ คุณมีความเสี่ยงใน',' ระดับสูง ต่อความไม่สบายในระบบทางเดินอาหาร โดยเฉพาะ','อาการท้องผูก ท้องเสีย และ ความผิดปกติของระบบภูมิคุ้มกัน'],
                img: 'high_r',
                posX_image: 50,
                posY_image: 230,
                posX_text: 420,
                posY_text: 255,
                fontFamily: '"Noto Sans Thai", sans-serif',

                label_2: ['ภูมิทัศน์ของไมโครไบโอมในลำไส้ของคุณแสดงความเสี่ยง ระดับสูง ต่อภาวะไม่สบายใน','ระบบทางเดินอาหาร โดยเฉพาะอาการท้องผูก ท้องเสีย และความผิดปกติของภูมิคุ้มกันในลำใส้'],
                Xlabel_2: 50,
                Ylabel_2: 157,
                fontFamily_label_2: '"Noto Sans Thai", sans-serif'
            }
        ]
    },
    {
        // Mental Health
        page: 35,
        value_comparing: [
            'Insomnia/ poor sleep quality',
            'Stress and anxiety'
        ],
        mapping_text: [
            {
                min: 0, 
                max: 3, 
                color_dot: '#8bcc2c', 
                label: ['จากข้อมูลไมโครไบโอมในลำใส้ของคุณ คุณมีความเสี่ยงใน ระดับต่ำ ','ต่ออาการที่เกี่ยวข้องกับการควบคุมอารมณ์และคุณภาพการนอนหลับ'],
                img: 'low_r',
                posX_image: 130,
                posY_image: 230,
                posX_text: 240,
                posY_text: 270,
                fontFamily: '"Noto Sans Thai", sans-serif',

                label_2: ['ผลการตรวจของคุณแสดงถึงความเปราะบาง ระดับต่ำ ต่อภาวะที่เกี่ยวข้อง','กับการควบคุมอารมณ์และคุณภาพการนอน'],
                Xlabel_2: 50,
                Ylabel_2: 157,
                fontFamily_label_2: '"Noto Sans Thai", sans-serif'
            },
            {
                min: 4, 
                max: 6, 
                color_dot: '#fa891f',
                label: ['จากข้อมูลไมโครไบโอมในลำใส้ของคุณ คุณมีความเสี่ยงใน ระดับปานกลาง',' ต่ออาการที่เกี่ยวข้องกับการควบคุมอารมณ์และคุณภาพการนอนหลับ'],
                img: 'moderate_r',
                posX_image: 50,
                posY_image: 230,
                posX_text: 300,
                posY_text: 275,
                fontFamily: '"Noto Sans Thai", sans-serif',

                label_2: ['ผลการตรวจของคุณแสดงถึงความเปราะบาง ระดับปานกลาง ต่อภาวะที่เกี่ยวข้อง','กับการควบคุมอารมณ์และคุณภาพการนอน'],
                Xlabel_2: 50,
                Ylabel_2: 157,
                fontFamily_label_2: '"Noto Sans Thai", sans-serif'
            },
            {
                min: 7, 
                max: 100, 
                color_dot: '#fa1f1f',
                label: ['จากข้อมูลไมโครไบโอมในลำใส้ของคุณ คุณมีความเสี่ยงใน',' ระดับสูง ต่ออาการที่เกี่ยวข้องกับการควบคุมอารมณ์','และคุณภาพการนอนหลับ'],
                img: 'high_r',
                posX_image: 50,
                posY_image: 230,
                posX_text: 422,
                posY_text: 250,
                fontFamily: '"Noto Sans Thai", sans-serif',

                label_2: ['ผลการตรวจของคุณแสดงถึงความเปราะบาง ระดับสูง ต่อภาวะที่เกี่ยวข้อง','กับการควบคุมอารมณ์และคุณภาพการนอน'],
                Xlabel_2: 50,
                Ylabel_2: 157,
                fontFamily_label_2: '"Noto Sans Thai", sans-serif'
            }
        ]
    },
]